import Vue from 'vue'
import LinkCollection from '@/components/LinkCollection.vue'

export default Vue.extend({
  name: 'ContainerComponentSelector',
  components: {
    LinkCollection
  },
  methods: {
    getContainerVueComponent (componentType) {
      switch (componentType) {
        case 'linkCollection':
          return LinkCollection
        default:
          return null
      }
    }
  }
})
